import styled from 'styled-components';
import { Form as Unform } from '@unform/web';

export const GraphicCards = styled.div`
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  place-content: start center;
  display: grid;
  gap: 10px;
`;

export const Form = styled(Unform)`
  display: grid;
  grid-template-columns: 1fr 1fr auto auto;
  place-items: center start;
  gap: 0 10px;
  margin-bottom: 10px;
  @media (max-width: 739px) {
    place-items: center;
    grid-template-columns: 1fr 1fr;
    & > div {
      grid-column: 1 / -1;
    }
  }
`;
